import { Builder, Input } from '@builder.io/sdk';
import { PageHeroImage } from './PageHeroImage';
import { getFilteredFormInputs } from '../LandingPageForm/LandingPageForm.registry';

const getFormInputs = () =>
  getFilteredFormInputs({
    excludedFields: ['heading', 'subHeading', 'useCardStyle'],
    defaultOverrides: {
      regLabel: 'Enter Registration Number',
      defaultDurationType: '2 days',
    },
  });

const ProductHeroImageConfig = {
  name: 'PageHeroImage',
  inputs: [
    {
      name: 'title',
      type: 'string',
      required: true,
    },
    {
      name: 'subtitle',
      type: 'string',
      required: false,
    },
    ...getFormInputs(),
    {
      name: 'image',
      type: 'file',
      required: true,
    },
  ] as Input[],
};

Builder.registerComponent(PageHeroImage, ProductHeroImageConfig);
